module.exports = __webpack_public_path__ + "static/media/module-program-card-banner-maximal-strength@2x.db9f71cc.png";